import { Country } from './country.js';

// / Time zone codes as defined in the IANA time zone database.
// / For more information see:
// /     * https://en.wikipedia.org/wiki/Tz_database
// /     * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
export enum TimeZoneRegion{
  EuropeBratislava = 'Europe/Bratislava',
  EuropeBucharest = 'Europe/Bucharest',
  EuropeBudapest = 'Europe/Budapest',
  EuropeLjubljana = 'Europe/Ljubljana',
  EuropeVienna = 'Europe/Vienna',
}

const timeZoneOfCountry = new Map<Country, Array<TimeZoneRegion>>([
  [Country.Austria, [TimeZoneRegion.EuropeVienna]],
  [Country.Hungary, [TimeZoneRegion.EuropeBudapest]],
  [Country.Romania, [TimeZoneRegion.EuropeBucharest]],
  [Country.Slovakia, [TimeZoneRegion.EuropeBratislava]],
  [Country.Slovenia, [TimeZoneRegion.EuropeLjubljana]],
]);

const countryOfTimeZone = new Map<TimeZoneRegion, Country>([
  [TimeZoneRegion.EuropeBratislava, Country.Slovakia],
  [TimeZoneRegion.EuropeBucharest, Country.Romania],
  [TimeZoneRegion.EuropeBudapest, Country.Hungary],
  [TimeZoneRegion.EuropeLjubljana, Country.Slovenia],
  [TimeZoneRegion.EuropeVienna, Country.Austria],
]);

export function getListOfTimeZonesForCountry(country: Country): TimeZoneRegion[] | null {
  return timeZoneOfCountry.get(country) ?? null;
}

export function getDefaultTimeZoneForCountry(country: Country): TimeZoneRegion | null {
  const timezones = timeZoneOfCountry.get(country);
  return timezones ? timezones[0] : null;
}

export function getCountryOfTimeZone(timezone: TimeZoneRegion): Country | null {
  return countryOfTimeZone.get(timezone) ?? null;
}
